import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';



const getAll = async (params = {}) => {
  
  const query = `
    query GetCarteraImagenes(
      $establecimiento: String,
      $search         : String,
      $tokenImagen    : String,
      $tipoImagen     : String,
      $page           : Int,
      $pageSize       : Int,
    ) {
      getCarteraImagenes(
        establecimiento: $establecimiento,
        search         : $search, 
        tokenImagen    : $tokenImagen,
        tipoImagen     : $tipoImagen,
        page           : $page,
        pageSize       : $pageSize,
      ) {
        total
        message
        status
        imagenes {
          id
          token
          nombre
          codigo
          estado
          precio

          estadoJson
          precioJson

          establecimiento
          tipoImagen {
            id
            descripcion
          }
          usuarioCreador {
            id
            username
          }
        }
      }
    }
  `;

  const variables = {
    ...params,
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return { total: 0, imagenes: [] };

    if (response.data?.errors) {
      console.error('GraphQL errors:', response.data.errors);
      return { total: 0, imagenes: [] };
    }

    const response2 = response.data?.data?.getCarteraImagenes;
    if( !response2 || response2.status !== 'Success' ) return { total: 0, imagenes: [] };

    const data = {
      total: response2.total,
      imagenes: response2.imagenes
    };

    return data;
  }catch(error){
    console.error('Error actualizando el estado de revision:', error);
    return { total: 0, imagenes: [] };
  }
}



const cambiarEstadoMultiples = async (idsImagenes, estado) => {

  if (!idsImagenes.length || !estado) {
    console.error('No se proporcionaron IDs de imagen o estado.');
    return false;
  }

  const query = ` 
    mutation cambiarEstadoImagen(
      $imagenDatos: ImagenEstadoInput!
    ) {
      cambiarEstadoImagen(imagenDatos: $imagenDatos) {
        status
        message
      }
    } 
  `;

  const variables = {
    imagenDatos: {
      id: idsImagenes,
      estado: estado,
    }
  }

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.cambiarEstadoImagen;
    if( response2.status !== 'SUCCESS' ) return null;

    return true

  }catch(error){
    console.error('Error actualizando el estado de revision:', error);
  }
}


const modificarTipoMultiples = async (idsImagenes, tipoImagen) => {

  if (!idsImagenes.length || !tipoImagen) {
    console.error('No se proporcionaron IDs de imagen o tipo.');
    return null;
  }

  const query = ` 
    mutation cambiarTipoImagen(
      $imagenDatos: ImagenTipoInput!
    ) {
      cambiarTipoImagen(imagenDatos: $imagenDatos) {
        status
        message
      }
    } 
  `;

  const variables = {
    imagenDatos: {
      id: idsImagenes,
      tipoImagen,
    }
  }

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.cambiarTipoImagen;
    if( response2.status !== 'SUCCESS' ) return null;

    return true;

  }catch(error){
    console.error('Error actualizando el tipo de imagen:', error);
    return null;
  }
}


const modificarEstablecimientoMultiples = async (idImagenes, idEstablecimiento) => {

  if (!idImagenes.length || !idEstablecimiento) {
    console.error('No se proporcionaron IDs de imagen o tipo.');
    return null;
  }

  const query = ` 
    mutation ModificarEstablecimientoMultiple(
      $idImagenes: [ID]!
      $idEstablecimiento: ID!
    ) {
      modificarEstablecimientoMultiple(
        idImagenes: $idImagenes
        idEstablecimiento: $idEstablecimiento
      ) {
        message
        status
      }
    } 
  `;

  const variables = {
    idImagenes,
    idEstablecimiento
  }

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.modificarEstablecimientoMultiple;
    if( response2.status !== 'SUCCESS' ) return null;

    return true;
  }catch(error){
    console.error('Error actualizando el tipo de imagen:', error);
    return null;
  }
}




const createItem = async (dataImagen) => {

  const query = `
    mutation RegistrarImagen(
      $establecimiento : String!
      $codigo          : String!
      $nombre          : String!
      $tipoImagen      : String!
      $precios         : String!
      $estados         : String!
  ) {
    registrarImagen(
      establecimiento : $establecimiento
      codigo          : $codigo
      nombre          : $nombre
      tipoImagen      : $tipoImagen
      precios         : $precios
      estados         : $estados
    ) {
        imagenCreada {
          id
          nombre
        }
        message
        status
      }
    }
  `;

  const variables = {
    ...dataImagen
  }


  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.registrarImagen;
    if( response2.status !== 'success' ) return null;
    return response2.imagenCreada;

  }catch(error){
    console.error('Error creando el item de cartera imagen:', error);
    return null;
  }
} 


const updateItem = async (dataImagen) => {

  const query = `
    mutation ActualizarImagen(
      $tokenImagen : String!
      $codigo      : String
      $nombre      : String
      $tipoImagen  : String
      $establecimiento : String
      $estados     : String
      $precios     : String
    ) {
      actualizarImagen(
        tokenImagen     : $tokenImagen
        codigo          : $codigo
        nombre          : $nombre
        tipoImagen      : $tipoImagen
        establecimiento : $establecimiento
        estados         : $estados
        precios         : $precios
      ) {
        imagenActualizada {
          id
          token
        }
        status
        message
      }
    }
  `;


  const variables = {
    ...dataImagen
  }

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });

    console.log(response);
    if(response.status !== 200) return null;

    const response2 = response.data.data.actualizarImagen;
    if( response2.status !== 'success' ) return null;

    const data = response2.imagenActualizada;
    return data;

  }catch(error){
    console.error('Error actualizando el item de cartera imagen:', error);
    return null;
  }
}

export const carteraImagenService = {
  getAll,
  cambiarEstadoMultiples,
  modificarTipoMultiples,
  modificarEstablecimientoMultiples,

  createItem,
  updateItem
}
